import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'afasEmployeeType', standalone: false })
export class AfasEmployeeTypePipe implements PipeTransform {
    transform(afasEmployeeId: Readonly<string | null | undefined>, type: Readonly<string>) {
        return afasEmployeeId?.substring(0, 1) === type;
    }
}
